import React from 'react';
export const LogoActGateway: React.FC = (): React.ReactElement => <img alt="logo-gateway" height="32px" src="/static/img/ACT-gateway-logo.svg" data-sentry-component="LogoActGateway" data-sentry-source-file="index.tsx" />;
export default LogoActGateway;